export const SET_FORM_LOADING = '@downloadCSV/SET_FORM_LOADING';
export const SET_VM_OPTIONS = '@downloadCSV/SET_VM_OPTIONS';
export const SET_FROM_DATE = '@downloadCSV/SET_FROM_DATE';
export const SET_TO_DATE = '@downloadCSV/SET_TO_DATE';
export const SET_VMID = '@downloadCSV/SET_VMID';
export const SET_SUBMIT_LOADING = '@downloadCSV/SET_SUBMIT_LOADING';



// WEBPACK FOOTER //
// ./src/Modules/DownloadCSV/constants.js